export const sanitizeCsvRow = <T extends { [key: string]: string }>(
  row: T,
): T => {
  return Object.keys(row).reduce(
    (acc, key) => {
      const value = row[key];
      if (value) {
        acc[key] = value
          .replaceAll('\n', '')
          .replaceAll('"', '')
          .replaceAll('\r', '');
      } else {
        acc[key] = '';
      }

      return acc;
    },
    {} as { [key: string]: string },
  ) as T;
};
